/**
 * UnlockDiagnosticCTA — the single CTA used across the entire site for
 * "Unlock the full diagnostic". Always opens the lead-capture dialog
 * (name/email/mobile) then hands over to Razorpay (₹3,999).
 *
 * Props it forwards:
 *   - className: visual styling slot (matches whichever section it lives in)
 *   - buttonLabel: override label text (default keeps the canonical copy)
 *   - testId: stable hook for testing
 */
import RazorpayCheckoutButton from "@/components/pivotbox/RazorpayCheckoutButton";

export default function UnlockDiagnosticCTA({
  className = "rzp-checkout-btn",
  buttonLabel = "Unlock the full diagnostic \u00A0\u2192",
  testId = "unlock-diagnostic-cta",
}) {
  return (
    <RazorpayCheckoutButton
      amount={399900}
      currency="INR"
      product="full_diagnostic"
      buttonLabel={buttonLabel}
      className={className}
      testId={testId}
      requireDetails
    />
  );
}
